import script from "./ErrorsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorsView.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorsView.vue?vue&type=style&index=0&id=5be8b63f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be8b63f"]])

export default __exports__